document.addEventListener('DOMContentLoaded', () => {
  const pads = n => String(n).padStart(2, '0');

  const tick = timerEl => {
    const banner = timerEl.closest('[data-end][data-behaviour]');
    if (!banner) return;

    const updateLabel = (numEl, value) => {
      const itemEl = numEl ? numEl.closest('.timer-item') : null;
      const labelEl = itemEl ? itemEl.querySelector('.timer-label') : null;
      if (!labelEl || !labelEl.dataset.labelSingular || !labelEl.dataset.labelPlural) return;

      labelEl.textContent = value === 1 ? labelEl.dataset.labelSingular : labelEl.dataset.labelPlural;
    };

    const endISO     = banner.getAttribute('data-end');
    const behaviour  = banner.getAttribute('data-behaviour');
    const repeatDaily= banner.getAttribute('data-daily') === 'true';

    let endDate      = new Date(endISO);
    const now        = new Date();

    /* ---------- DAILY MODE ---------- */
    if (repeatDaily) {
      // create target today at given HH:MM:SS
      endDate = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        endDate.getHours(),
        endDate.getMinutes(),
        endDate.getSeconds()
      );
      // if we've passed it, roll to tomorrow
      if (now >= endDate) {
        endDate.setDate(endDate.getDate() + 1);
      }

    }

    /* ---------- TIME DIFF ---------- */
    let diff = Math.max(0, endDate - now);


    if (diff === 0) {
      if (behaviour === 'hide_banner') banner.remove();
      else timerEl.remove();
      return;
    }

    const totalSec = Math.floor(diff / 1000);
    const d = Math.floor(totalSec / 86400);
    const h = Math.floor((totalSec % 86400) / 3600);
    const m = Math.floor((totalSec % 3600)  / 60);
    const s = totalSec % 60;


    /* ---------- RENDER ---------- */
    const daysEl = timerEl.querySelector('[data-d]');
    const hoursEl = timerEl.querySelector('[data-h]');
    const minutesEl = timerEl.querySelector('[data-m]');
    const secondsEl = timerEl.querySelector('[data-s]');
    const rollDaysIntoHours = timerEl.hasAttribute('data-roll-days-into-hours');
    const displayHours = rollDaysIntoHours ? Math.floor(totalSec / 3600) : h;

    if (daysEl) daysEl.textContent = pads(d);
    if (hoursEl) hoursEl.textContent = pads(displayHours);
    if (minutesEl) minutesEl.textContent = pads(m);
    if (secondsEl) secondsEl.textContent = pads(s);
    if (daysEl) updateLabel(daysEl, d);
    if (hoursEl) updateLabel(hoursEl, displayHours);

    /* hide “days” column in daily mode or when <1 day */
    const daysItem = daysEl ? daysEl.closest('.timer-item') : null;
    if (daysItem) daysItem.style.display = (rollDaysIntoHours || repeatDaily || d === 0) ? 'none' : '';
  };

  /* ---------- INITIALISE ---------- */
  const timers = document.querySelectorAll('.timer');
  if (!timers.length) return;

  const run = () => timers.forEach(tick);
  run();                                   // first draw
  setInterval(() => { if (!document.hidden) run(); }, 1000);

});

